/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_LedeInputs */

const en_for_whom_lede = /** @type {(inputs: For_Whom_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A trainer, a dietician or a physio, and between visits an app that guides you day by day. For people just starting out and for people chasing new bests.`)
};

const pl_for_whom_lede = /** @type {(inputs: For_Whom_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener, dietetyk albo fizjoterapeuta, a między wizytami aplikacja, która prowadzi Cię dzień po dniu. Dla tych, którzy zaczynają, i dla tych, którzy walczą o rekordy.`)
};

/**
* | output |
* | --- |
* | "A trainer, a dietician or a physio, and between visits an app that guides you day by day. For people just starting out and for people chasing new bests." |
*
* @param {For_Whom_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_lede = /** @type {((inputs?: For_Whom_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_lede(inputs)
	return en_for_whom_lede(inputs)
});